
import './InfosFormations.css'

const InfosFormations = ({ item }) => {

    const renderContent = () => {
        if (item.Formations == null) {
            return (
                <div className="txt-none">
                    Formation non renseignée
                </div>
            )
        }

        return (
            <div className="txt-size-095 paddingH-20 textWithBreaks">
                {item.Formations}
            </div>
        )
    }


    return (
        <div className="infos-formations">
            <div className="title">Formation & Parcours professionnel</div>
            {renderContent()}
        </div>

    )
}

export default InfosFormations